/** @deprecated Program split removed; search uses {@link LAW_COLLEGES} for all roles. */
export type LawCollegeProgramFilter = 'all';

/**
 * Major HEC / Pakistan Bar Council recognized law colleges and university law faculties.
 * Sources: Wikipedia list of law schools in Pakistan, PBC recognized institutes.
 */
export const PAKISTAN_LLB_COLLEGES = [
  'Abbott Law College, Abbottabad',
  'Abdul Wali Khan University Mardan - Department of Law',
  'Abraham Lincoln School of Law, Bannu',
  'Air University - Department of Law, Islamabad',
  'Al-Jinnah Institute for Law, Sargodha',
  'Allama Iqbal Law College, Sialkot',
  'Ayub Law College, Haripur',
  'Bahauddin Zakariya University - Faculty of Law, Multan',
  'Bahria University Law School, Islamabad',
  'Bacha Khan University - Department of Law',
  'Balochistan University Law College, Quetta',
  'Bilawal Bhutto Zardari Law College, Qambar Shahdadkot',
  'Centre for Learning Law and Business (CLLB), Peshawar',
  'CIMS School of Law, Lahore',
  'City Law College, Lahore',
  'City School of Law, Quetta',
  'College of Legal Studies, Peshawar',
  'COMSATS University Islamabad - Department of Law',
  'Cornelius Law College, Sargodha',
  'Federal Law College, Islamabad',
  'Frontier Law College, Dera Ismail Khan',
  'Frontier Law College, Peshawar',
  'GIFT University - School of Law, Gujranwala',
  'Gomal University Law College, Dera Ismail Khan',
  'Government College University Faisalabad - Faculty of Law',
  'Government Law College, Khairpur',
  'Govt. ABD Law College, Sukkur',
  'Govt. Hyderabad Sindh Law College',
  'Govt. Jinnah Law College, Hyderabad',
  'Govt. Pir Illahi Bux Law College, Dadu',
  'Govt. Shaheed Benazir Bhutto Law College, Larkana',
  'Gujrat Law College, Gujrat',
  'Haji Moula Bux Law College, Shikarpur',
  'Hamdard University - Faculty of Law, Karachi',
  'Hamayat Islam Law College, Lahore',
  'Hazara University - Department of Law, Mansehra',
  'HRPC School of Law, Lahore',
  'Institute of Legal Studies, Peshawar',
  'International Islamic University - Faculty of Sharia and Law, Islamabad',
  'Islamia College University - Department of Shariah and Law, Peshawar',
  'Islamia Law College, Karachi',
  'Islamia Law College, Peshawar',
  'Islamia University Bahawalpur - Department of Law',
  'Jhalawan Law College, Khuzdar',
  'Jinnah Law College, Jhelum',
  'Jinnah Law College, Peshawar',
  'Jinnah Sindh Law College, Karachi',
  'Justice Inn Law College, Narowal',
  'Justice Law College, Abbottabad',
  'Karakoram International University - Department of Law, Gilgit',
  'Kashmir Law College, Muzaffarabad',
  'Khyber Law College, Peshawar',
  'Kohat Law College, Kohat',
  'Kohat University of Science and Technology - Department of Law',
  'Lahore Garrison University - School of Law',
  'Lahore School of Law',
  'Lahore University of Management Sciences - Shaikh Ahmad Hassan School of Law',
  'Lasbela University - Faculty of Law, Uthal',
  'Law College, Ghotki',
  'Law College, Mirpur Khas',
  'Law College, Naushahro Feroze',
  'Leads Law College, Lahore',
  'Luqman College of Law, Dera Ismail Khan',
  'Lyallpur Law College, Faisalabad',
  'Mardan Law College, Mardan',
  'Minhaj University - School of Law, Lahore',
  'Mirpur University of Science and Technology - Law School',
  'Muhammad Ali Jinnah Law College, Gujranwala',
  'Muhammadan Law College, Sheikhupura',
  'Muslim Law College, Rawalpindi',
  'Muslim Law College, Swat',
  'National Institute of Legal Studies, Attock',
  'National Law College, Quetta',
  'National University of Modern Languages - Department of Law, Islamabad',
  'Pakistan College of Law, Lahore',
  'Peshawar Law College',
  'Punjab Law College, Lahore',
  'Punjab University Law College, Lahore',
  'Quaid-e-Azam Institute of Legal Studies, Nowshera',
  'Quaid-e-Azam Law College, Lahore',
  'Quaid-e-Azam Law College, Nawabshah',
  'Quaid-e-Azam Law College, Okara',
  'Quaid-i-Azam University - School of Law, Islamabad',
  'Qurtuba University - Faculty of Law, Dera Ismail Khan',
  'Rawalpindi Law College',
  'Riphah International University - Faculty of Law, Islamabad',
  'Riphah International University - Faculty of Law, Lahore',
  'Royal Law College, Arifwala',
  'Saani Islamia Law College, Haripur',
  'Sardar Noor Muhammad Khan Bijarani Law College, Kandhkot',
  'Sarhad University - College of Law, Peshawar',
  'Shah Abdul Latif University - Faculty of Law, Khairpur',
  'Shaheed Benazir Bhutto University - Department of Law, Nawabshah',
  'Sindh Mehran Institute of Law, Jamshoro',
  'Sindh Muslim Government Law College, Karachi',
  'Sukkur IBA University - Department of Law',
  'Superior University - School of Law, Lahore',
  'Supreme Law College, Peshawar',
  'Swabi Law College, Swabi',
  'The Institute of Legal Studies (TILS), Lahore',
  'Toppers Law College, Lahore',
  'Unified Law College, Chiniot',
  'University of Azad Jammu and Kashmir - Faculty of Law, Muzaffarabad',
  'University of Central Punjab - Faculty of Law, Lahore',
  'University of Gujrat - Faculty of Law',
  'University of Karachi - School of Law',
  'University of Kotli - Faculty of Law',
  'University of Lahore - College of Law',
  'University of Malakand - Department of Law',
  'University of Management and Technology - School of Law and Policy, Lahore',
  'University of Peshawar - Khyber Law College',
  'University of Sargodha - Department of Law',
  'University of Sindh - Faculty of Law, Jamshoro',
  'University of South Asia - College of Law, Lahore',
  'University of Swat - Department of Law',
  'Zarghoon Law College, Quetta',
] as const;

/**
 * External LLB teaching centres in Pakistan (University of London programme, etc.).
 * Listed by institution name only — same search pool as local law colleges.
 */
export const EXTERNAL_LLB_COLLEGES = [
  'Beaconhouse International College, Faisalabad',
  'Beaconhouse International College, Lahore',
  'Blackstone School of Law & Business, Lahore',
  'Denning Law School, Karachi',
  'International College for Legal Studies, Lahore',
  'Islamabad School of Law, Islamabad',
  'Ivy College of Management Sciences, Faisalabad',
  'Ivy College of Management Sciences, Islamabad',
  'LGS International Degree Programme, Lahore',
  'Metropolitan International United College, Islamabad',
  'Roots Ivy International School, Islamabad',
  'School of International Law, Islamabad',
  'The Institute of Legal Studies, Islamabad',
  'The Institute of Legal Studies, Multan',
  'The Institute of Legal Studies, Peshawar',
  'The Millennium Universal College (Roots Millennium), Islamabad',
  'The Millennium Universal College (Roots Millennium), Karachi',
  'The Millennium Universal College (Roots Millennium), Lahore',
  'The Millennium Universal College (Roots Millennium), Rawalpindi',
] as const;

function dedupeLawColleges(names: readonly string[]): readonly string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const name of names) {
    const key = name.trim().toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      out.push(name);
    }
  }
  return out.sort((a, b) => a.localeCompare(b));
}

/** Unified law school list for lawyers and law students. */
export const LAW_COLLEGES = dedupeLawColleges([
  ...PAKISTAN_LLB_COLLEGES,
  ...EXTERNAL_LLB_COLLEGES,
]);

/** @deprecated Use {@link LAW_COLLEGES} */
export const UNIVERSITY_OF_LONDON_LLB_COLLEGES = EXTERNAL_LLB_COLLEGES;

/** @deprecated Use PAKISTAN_LLB_COLLEGES */
export const PAKISTAN_LAW_COLLEGES = PAKISTAN_LLB_COLLEGES;

export type PakistanLawCollege = (typeof PAKISTAN_LLB_COLLEGES)[number];

export interface LawCollegeAutocompleteMatch {
  full: string;
  suffix: string;
}

/** @deprecated All roles use the unified {@link LAW_COLLEGES} list. */
export function resolveLawCollegeProgramFilter(): LawCollegeProgramFilter {
  return 'all';
}

export function getLawCollegesForProgram(_program?: LawCollegeProgramFilter): readonly string[] {
  return LAW_COLLEGES;
}

function resolveCollegePool(): readonly string[] {
  return LAW_COLLEGES;
}

const LAW_COLLEGE_STOP_WORDS = new Set([
  'for',
  'of',
  'the',
  'and',
  'in',
  'at',
  'a',
  'an',
  '&',
  '—',
]);

/** Extra short forms students commonly type (lowercase, no spaces). */
const LAW_COLLEGE_MANUAL_ALIASES: Record<string, readonly string[]> = {
  'Pakistan College of Law, Lahore': ['pcl'],
  'Punjab University Law College, Lahore': ['pulc'],
  'Sindh Muslim Government Law College, Karachi': ['smcl', 'sindh muslim'],
  'Quaid-i-Azam University - School of Law, Islamabad': ['qau', 'qau law'],
  'International Islamic University - Faculty of Sharia and Law, Islamabad': ['iiui'],
  'University of Management and Technology - School of Law and Policy, Lahore': ['umt'],
  'Lahore University of Management Sciences - Shaikh Ahmad Hassan School of Law': ['lums'],
  'The Institute of Legal Studies (TILS), Lahore': ['tils'],
  'The Institute of Legal Studies, Islamabad': ['tils'],
  'The Institute of Legal Studies, Peshawar': ['tils'],
  'The Institute of Legal Studies, Multan': ['tils'],
  'School of International Law, Islamabad': ['sil'],
  'International College for Legal Studies, Lahore': ['icls'],
  'Denning Law School, Karachi': ['dls', 'denning'],
  'Beaconhouse International College, Lahore': [
    'bic',
    'beaconhouse',
    'beacon house',
    'beaconhouse international',
  ],
  'Beaconhouse International College, Faisalabad': [
    'bic',
    'beaconhouse',
    'beacon house',
    'beaconhouse faisalabad',
  ],
  'Blackstone School of Law & Business, Lahore': [
    'bsol',
    'blackstone',
    'black stone',
    'blackstone law',
  ],
  'Roots Ivy International School, Islamabad': [
    'roots',
    'roots ivy',
    'rootsivy',
    'riv',
    'roots ivy international',
  ],
  'Islamabad School of Law, Islamabad': ['isl', 'islamabad school of law'],
  'The Millennium Universal College (Roots Millennium), Islamabad': [
    'tmuc',
    'roots millennium',
    'roots',
    'millennium',
    'rms',
  ],
  'The Millennium Universal College (Roots Millennium), Lahore': [
    'tmuc',
    'roots millennium',
    'roots',
    'millennium',
    'rms',
  ],
  'The Millennium Universal College (Roots Millennium), Karachi': [
    'tmuc',
    'roots millennium',
    'roots',
    'millennium',
    'rms',
  ],
  'The Millennium Universal College (Roots Millennium), Rawalpindi': [
    'tmuc',
    'roots millennium',
    'roots',
    'millennium',
    'rms',
  ],
  'Centre for Learning Law and Business (CLLB), Peshawar': ['cllb'],
  'Khyber Law College, Peshawar': ['klc'],
  'University of Peshawar - Khyber Law College': ['klc', 'up klc'],
};

function normalizeLawCollegeQuery(query: string): string {
  return query.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
}

function stripCitySuffix(name: string): string {
  const comma = name.indexOf(',');
  return comma >= 0 ? name.slice(0, comma).trim() : name;
}

function getInstitutionPart(college: string): string {
  const uolPrefix = 'University of London — ';
  if (college.startsWith(uolPrefix)) {
    return college.slice(uolPrefix.length);
  }
  return college;
}

function extractParentheticalKeys(name: string): string[] {
  const keys: string[] = [];
  for (const match of name.matchAll(/\(([^)]+)\)/g)) {
    const inner = match[1].trim();
    if (inner) {
      keys.push(normalizeLawCollegeQuery(inner));
    }
  }
  return keys;
}

function buildWordAcronym(namePart: string): string {
  const withoutParens = namePart.replace(/\([^)]*\)/g, ' ').trim();
  const words = withoutParens.split(/[\s—–-]+/).filter((w) => w.length > 0);
  return words
    .filter((w) => !LAW_COLLEGE_STOP_WORDS.has(w.toLowerCase()))
    .map((w) => w[0])
    .join('')
    .toLowerCase();
}

function buildCollegeSearchKeys(college: string): string[] {
  const keys = new Set<string>();
  const lowerName = college.toLowerCase();
  const institution = getInstitutionPart(college);
  const lowerInstitution = institution.toLowerCase();

  keys.add(lowerName);
  keys.add(normalizeLawCollegeQuery(lowerName));
  keys.add(lowerInstitution);
  keys.add(normalizeLawCollegeQuery(lowerInstitution));

  extractParentheticalKeys(college).forEach((k) => keys.add(k));
  extractParentheticalKeys(institution).forEach((k) => keys.add(k));

  const mainPart = stripCitySuffix(institution);
  const acronym = buildWordAcronym(mainPart);
  if (acronym.length >= 2) {
    keys.add(acronym);
  }

  const emDashParts = mainPart.split('—').map((s) => s.trim());
  if (emDashParts.length > 1) {
    const afterDash = emDashParts[emDashParts.length - 1];
    const subAcronym = buildWordAcronym(afterDash);
    if (subAcronym.length >= 2) {
      keys.add(subAcronym);
    }
  }

  const manual = LAW_COLLEGE_MANUAL_ALIASES[college];
  if (manual) {
    manual.forEach((alias) => keys.add(normalizeLawCollegeQuery(alias)));
  }

  return Array.from(keys);
}

const collegeSearchKeyCache = new Map<string, string[]>();

function getCollegeSearchKeys(college: string): string[] {
  let cached = collegeSearchKeyCache.get(college);
  if (!cached) {
    cached = buildCollegeSearchKeys(college);
    collegeSearchKeyCache.set(college, cached);
  }
  return cached;
}

function queryTokens(query: string): string[] {
  return query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((t) => t.length >= 2 && !LAW_COLLEGE_STOP_WORDS.has(t));
}

function collegeMatchesQuery(college: string, query: string): boolean {
  const raw = query.trim().toLowerCase();
  if (!raw) return false;

  const q = normalizeLawCollegeQuery(query);
  const lowerName = college.toLowerCase();
  const institution = getInstitutionPart(college).toLowerCase();
  const normName = normalizeLawCollegeQuery(lowerName);
  const normInstitution = normalizeLawCollegeQuery(institution);

  if (lowerName.startsWith(raw) || institution.startsWith(raw)) {
    return true;
  }

  if (q.length >= 2 && (normName.includes(q) || normInstitution.includes(q))) {
    return true;
  }

  const tokens = queryTokens(query);
  if (tokens.length > 0 && tokens.every((t) => institution.includes(t) || lowerName.includes(t))) {
    return true;
  }

  return getCollegeSearchKeys(college).some(
    (key) => key.startsWith(q) || (q.length >= 2 && key.includes(q)),
  );
}

function scoreCollegeMatch(college: string, query: string): number {
  const raw = query.trim().toLowerCase();
  const q = normalizeLawCollegeQuery(query);
  const institution = getInstitutionPart(college).toLowerCase();
  const lowerName = college.toLowerCase();

  if (lowerName === raw || institution === raw) return 100;
  if (institution.startsWith(raw) || lowerName.startsWith(raw)) return 90;
  if (getCollegeSearchKeys(college).some((key) => key === q)) return 85;

  const tokens = queryTokens(query);
  if (tokens.length > 0 && tokens.every((t) => institution.includes(t))) return 70;

  if (normalizeLawCollegeQuery(institution).includes(q)) return 60;
  if (getCollegeSearchKeys(college).some((key) => key.startsWith(q))) return 50;

  return 10;
}

function findMatchingColleges(input: string): string[] {
  const query = input.trim();
  if (!query) return [];

  return resolveCollegePool()
    .filter((college) => collegeMatchesQuery(college, query))
    .map((college) => ({ college, score: scoreCollegeMatch(college, query) }))
    .sort((a, b) => b.score - a.score || a.college.localeCompare(b.college))
    .map(({ college }) => college);
}

/** Inline completion when exactly one college matches (name prefix or short form). */
export function getLawCollegeAutocomplete(
  input: string,
  _program?: LawCollegeProgramFilter,
): LawCollegeAutocompleteMatch | null {
  const query = input.trim();
  if (!query) return null;

  const matches = findMatchingColleges(query);
  if (matches.length !== 1) return null;

  const match = matches[0];
  const lowerQuery = query.toLowerCase();
  if (match.toLowerCase().startsWith(lowerQuery) && match.length > query.length) {
    return { full: match, suffix: match.slice(query.length) };
  }

  return { full: match, suffix: '' };
}

/** Colleges matching name prefix or short form / acronym. */
export function searchLawColleges(
  input: string,
  _program?: LawCollegeProgramFilter,
  limit = 12,
): string[] {
  return findMatchingColleges(input).slice(0, limit);
}

export function isExactLawCollege(value: string, _program?: LawCollegeProgramFilter): boolean {
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) return false;
  return resolveCollegePool().some((college) => college.toLowerCase() === trimmed);
}

/** @deprecated Use searchLawColleges */
export function searchPakistanLawColleges(input: string, limit = 6): string[] {
  return searchLawColleges(input, undefined, limit);
}
